import React from "react";

export default function Footer() {
  return (
    <div className="text-center bg-background-100 w-full text-neutral-500 flex gap-2 text-[12px] font-semibold items-center justify-center py-4">
      Powered By <img src="/images/empedance.svg" alt="" className="h-12" />
    </div>
  );
}
